import {Tooltip} from "@mui/material";
import React from "react";
import {AiOutlineQuestionCircle} from "react-icons/ai";

const Explanation = ({explanation}) => {
  return (
    <div className="explanation-wrapper">
      <Tooltip title={explanation} arrow placement="right">
        <div className="explanation-icon">
          <AiOutlineQuestionCircle />
        </div>
      </Tooltip>
    </div>
  );
};

export default Explanation;
